import { dataThumbDownSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconThumbDownSolid = /*#__PURE__*/createIcon(dataThumbDownSolid)
export default IconThumbDownSolid
